import Vue from 'vue'
import Router from 'vue-router'
import prescriptionlist from '@/components/order/prescriptionlist'
import order_confirm from '@/components/order/order_confirm'
import bindPhone from '@/components/order/bindPhone'
import order from '@/components/order/order'
import order_login from '@/components/order/order_login'
import order_detail from '@/components/order/order_detail'
import coupon from '@/components/order/coupon'
import getcoupon from '@/components/coupon/coupon'
import demo from '@/components/order/demo'
import orderresult from '@/components/order/orderresult'
import address from '@/components/address/address'
import addresslist from '@/components/address/addresslist'
import surveylist from '@/components/surveys/surveylist'
import buildsurvey from '@/components/surveys/buildsurvey'
import defalutsurvey from '@/components/surveys/defalutsurvey'
import bulidquestion from '@/components/surveys/bulidquestion'
import systempreview from '@/components/surveys/systempreview'
import buildpreview from '@/components/surveys/buildpreview'
import surveryanswer from '@/components/surveys/surveryanswer'
import surveydetail from '@/components/surveys/surveydetail'
import consultingdetail from '@/components/surveys/consultingdetail'
import surveydetaillist from '@/components/surveys/surveydetaillist'
import businesscard from '@/components/doctor/businesscard'
import anlist from '@/components/doctor/anlist'
import andetail from '@/components/doctor/andetail'
import selectprescription from '@/components/doctor/selectprescription'
import patient from '@/components/followup/patient_view'
import followup_detail from '@/components/followup/followup_detail'
import download from '@/components/download/download'
import mangeprescriptions from '@/components/prescription/mangeprescriptions'
import editPrescription from '@/components/prescription/editPrescription'
import article from '@/components/article/article'
import medicineorder from '@/components/order/medicineorder'
import medicineorderdetail from '@/components/order/medicineorderdetail'
import medicineorderresult from '@/components/order/medicineorderresult'
import findPassword from "@/components/order/findPassword";
import getVer from "@/components/order/getVer";
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/article',
      name: 'article',
      component: article,
      meta: {
        title: "文章详情"
      }
    },
    {
      path: '/order_confirm',
      name: 'order_confirm',
      component: order_confirm,
      meta: {
        title: "处方单确认"
      }
    },
    {
      path: '/bindPhone',
      name: 'bindPhone',
      component: bindPhone,
      meta: {
        title: "绑定手机号"
      }
    },
    {
      path: '/prescriptionlist',
      name: 'prescriptionlist',
      component: prescriptionlist,
      meta: {
        title: "处方单"
      }
    },
    {
      path: '/order',
      name: 'order',
      component: order,
      meta: {
        title: "提交药品订单"
      }
    },
    {
      path: '/order_login',
      name: 'order_login',
      component: order_login,
      meta: {
        title: "登录处方单"
      }
    },
    {
      path: '/findPassword',
      name: 'findPassword',
      component: findPassword,
      meta: {
        title: "找回密码"
      }
    },
    {
      path: '/getVer',
      name: 'getVer',
      component: getVer,
      meta: {
        title: "获取验证码"
      }
    },
    {
      path: '/order_detail',
      name: 'order_detail',
      component: order_detail,
      meta: {
        title: "订单详情"
      }
    },
    {
      path: '/medicineorder',
      name: 'medicineorder',
      component: medicineorder,
      meta: {
        title: "提交药品订单"
      }
    },
    {
      path: '/medicineorderdetail',
      name: 'medicineorderdetail',
      component: medicineorderdetail,
      meta: {
        title: "订单详情"
      }
    },
    {
      path: '/medicineorderresult',
      name: 'medicineorderresult',
      component: medicineorderresult,
      meta: {
        title: "已支付"
      }
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: coupon,
      meta: {
        title: "选择优惠券"
      }
    },{
      path: '/getcoupon',
      name: 'getcoupon',
      component: getcoupon,
      meta: {
        title: "领取优惠券"
      }
    },{
      path: '/orderresult',
      name: 'orderresult',
      component: orderresult,
      meta: {
        title: "已支付"
      }
    },
    {
      path: '/demo',
      name: 'demo',
      component: demo,
      meta: {
        title: "demo"
      }
    },
    {
      path: '/address',
      name: 'address',
      component: address,
      meta: {
        title: "编辑地址"
      }
    },
    {
      path: '/addresslist',
      name: 'addresslist',
      component: addresslist,
      meta: {
        title: "收货地址"
      }
    },
    {
      path: '/patient',
      name: 'patient',
      component: patient,
      meta: {
        title: "填写随访复诊单"
      }
    },
    {
      path: '/followup_detail',
      name: 'followup_detail',
      component: followup_detail,
      meta: {
        title: "随访复诊单"
      }
    },
    {
      path: '/surveylist',
      name: 'surveylist',
      component: surveylist,
      meta: {
        title: "问诊单"
      }
    },
    {
      path: '/buildsurvey',
      name: 'buildsurvey',
      component: buildsurvey,
      meta: {
        title: "编辑问诊单"
      }
    },
    {
      path: '/defalutsurvey',
      name: 'defalutsurvey',
      component: defalutsurvey,
      meta: {
        title: "设置默认问诊单"
      }
    },
    {
      path: '/bulidquestion',
      name: 'bulidquestion',
      component: bulidquestion,
      meta: {
        title: "创建问题"
      }
    }, {
      path: '/systempreview/:id',
      name: 'systempreview',
      component: systempreview,
      meta: {
        title: "系统问诊单"
      }
    }, {
      path: '/buildpreview/:id',
      name: 'buildpreview',
      component: buildpreview,
      meta: {
        title: "自建问诊单"
      }
    }, {
      path: '/download',
      name: 'download',
      component: download,

    }, {
      path: '/surveryanswer',
      name: 'surveryanswer',
      component: surveryanswer,
      meta: {
        title: "填写问诊单"
      }
    }, {
      path: '/surveydetail',
      name: 'surveydetail',
      component: surveydetail,
      meta: {
        title: "问诊单"
      }
    },
    {
      path: '/consultingdetail',
      name: 'consultingdetail',
      component: consultingdetail,
      meta: {
        title: "咨询详情"
      }
    },
    {
      path: '/surveydetaillist',
      name: 'surveydetaillist',
      component: surveydetaillist,
      meta: {
        title: "咨询详情"
      }
    }, {
      path: '/businesscard/:id',
      name: 'businesscard',
      component: businesscard,
      meta: {
        title: "添加患者"
      }
    }, {
      path: '/anlist',
      name: 'anlist',
      component: anlist,
      meta: {
        title: "搜索结果"
      }
    }, {
      path: '/andetail/:id',
      name: 'andetail',
      component: andetail,
      meta: {
        title: "医案详情"
      }
    }, {
      path: '/selectprescription',
      name: 'selectprescription',
      component: selectprescription,
      meta: {
        title: "选择常用方"
      }
    }, {
      path: '/mangeprescriptions',
      name: 'mangeprescriptions',
      component: mangeprescriptions,
      meta: {
        title: "常用方"
      }
    }, {
      path: '/editPrescription',
      name: 'editPrescription',
      component: editPrescription,
      meta: {
        title: "编辑常用方"
      }
    },
    {
      path: '*',
      redirect: '/order'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js